import { cn } from '../../lib/utils';
import Badge from './Badge';
import { getStatusMeta } from './status';

/**
 * Spójny status badge dla orders / batches.
 * Pobiera label + ikonę + variant z centralnego status.js.
 *
 * Props:
 *  - status:   string — klucz w STATUS_META (done/sent/processing/queued/pending/error/failed/...)
 *  - size:     'sm' | 'md' | 'lg' (default 'md')
 *  - showIcon: bool (default true)
 *  - showDot:  bool (default — z meta.dot)
 *  - label:    override etykiety
 */
export default function StatusBadge({
  status,
  size = 'md',
  showIcon = true,
  showDot,
  label,
  className,
}) {
  const meta = getStatusMeta(status);
  const Icon = meta.icon;
  const dot = showDot ?? meta.dot ?? false;
  const iconSize = size === 'sm' ? 'w-2.5 h-2.5' : 'w-3 h-3';

  return (
    <Badge variant={meta.variant} size={size} dot={dot && !showIcon} className={className}>
      {showIcon && Icon && (
        <Icon className={cn(iconSize, meta.spin && 'animate-spin')} />
      )}
      {label ?? meta.label}
    </Badge>
  );
}
